import { createRoot } from 'react-dom/client'
import client, { type BasedClient } from '@based/sdk/client'
import basedConfig from '../../based'
import { Provider as BasedClientProvider } from '@based/sdk/react'
import { ThemeProvider } from './providers/useTheme'
import { App } from './app'
import { AppCtxProvider } from './providers/useAppCtx'
import './index.css'

var e = 'Unsupported browser'
if (!Blob.prototype.arrayBuffer) {
  dispatchEvent(new ErrorEvent('error', { message: e }))
  throw Error(e)
}

var ua = navigator.userAgent
function test(f, minV) {
  var idx = ua.indexOf(f)
  if (idx !== -1) {
    var vStr = ua.substring(idx + f.length)
    var match = vStr.match(/^(\d+)/)
    if (match) {
      var v = parseInt(match[1], 10)
      if (v < minV) {
        dispatchEvent(new ErrorEvent('error', { message: e }))
        throw Error(e)
      }
    }
  }
}

test('Firefox/', 100)
test('Chrome/', 95)
test('Edg/', 95)
if (
  ua.indexOf('Safari/') !== -1 &&
  ua.indexOf('Chrome/') === -1 &&
  ua.indexOf('Edg/') === -1
) {
  test('Version/', 14)
}

export const based: BasedClient = client(basedConfig)

// export const basedClient: BasedClient = client(basedConfig)
// const originalCall = basedClient.call.bind(basedClient)
// const originalQuery = basedClient.query.bind(basedClient)
// const originalChannel = basedClient.channel.bind(basedClient)

// type LogEntry = { ts: number; type: string; args: any[] }
// const basedLog: LogEntry[] = []
// const seenQueryKeys = new Set<string>()

// ;(window as any).__basedLog = () => {
//   console.table(basedLog.map((e) => ({
//     time: new Date(e.ts).toLocaleTimeString(),
//     type: e.type,
//     args: JSON.stringify(e.args),
//   })))
//   return basedLog
// }

// function record(type: string, args: any[]) {
//   basedLog.push({ ts: Date.now(), type, args })
// }

// basedClient.call = ((...args: any[]) => {
//   record('call', args)
//   return originalCall(...args)
// }) as typeof basedClient.call

// basedClient.query = ((...args: any[]) => {
//   const key = JSON.stringify(args)
//   if (!seenQueryKeys.has(key)) {
//     record('query', args)
//     seenQueryKeys.add(key)
//   }
//   return originalQuery(...args)
// }) as typeof basedClient.query

// basedClient.channel = ((...args: any[]) => {
//   record('channel', args)
//   const ch = originalChannel(...args)
//   const originalSubscribe = ch.subscribe.bind(ch)
//   const originalPublish = ch.publish.bind(ch)
//   ch.subscribe = (onMessage, onError?) => {
//     record('channel.subscribe', [args[0], { onMessage, onError }])
//     return originalSubscribe(onMessage, onError)
//   }
//   ch.publish = (message) => {
//     record('channel.publish', [args[0], message])
//     return originalPublish(message)
//   }
//   return ch
// }) as typeof basedClient.channel

// export const based: BasedClient = basedClient

const rootElement = document.getElementById('root')!
const root = createRoot(rootElement)

root.render(
  <BasedClientProvider client={based}>
    <ThemeProvider variant="light">
      <AppCtxProvider>
        <App />
      </AppCtxProvider>
    </ThemeProvider>
  </BasedClientProvider>,
)
